import {
  Entity, PrimaryGeneratedColumn, Column, OneToMany, OneToOne, JoinColumn
} from 'typeorm';
import { IsOptional, IsInt } from 'class-validator';
import { ResultadoDeExame } from './ResultadoDeExame';
import { OpcaoStatus } from '../types';
import { GrupoExame } from './GrupoExame';

@Entity({name: "exames"})
export class Exame {
  @PrimaryGeneratedColumn()
  @IsOptional()
  @IsInt()
  id?: number;

  @Column()
  grupo_exame_id: number;

  @Column()
  nome: string;
  
  @Column()
  texto: string;

  @Column()
  ordem: number;

  @Column('jsonb')
  @IsOptional()
  opcoes_resultados: string[];

  @Column('jsonb')
  opcoes_status: OpcaoStatus[];

  // RELATIONS
  @OneToOne(type => GrupoExame)
  @JoinColumn({ name: 'grupo_exame_id' })
  grupo_exame?: GrupoExame;

  @OneToMany(type => ResultadoDeExame, resultados_de_exames => resultados_de_exames.exame)
  resultados_de_exames?: ResultadoDeExame[];
}
